import { render, staticRenderFns } from "./BDialogActions.vue?vue&type=template&id=bc28fe44"
import script from "./BDialogActions.vue?vue&type=script&lang=js"
export * from "./BDialogActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports